import './thefifth4fb/style';
import FormStructure from './thefifth4fb/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/kevin/projects/inquiry-renderer/client_forms/includes.js